import React from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HideSourceOutlinedIcon from '@mui/icons-material/HideSourceOutlined';

import { IPlanningRecommendation } from './planningcontrol.models';

type Props = {
  item: IPlanningRecommendation;
  busy?: boolean;
  onAccept: (item: IPlanningRecommendation) => void;
  onModify: (item: IPlanningRecommendation) => void;
  onIgnore: (item: IPlanningRecommendation) => void;
};

export default class RecommendationCard extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { item, busy } = this.props;
    const resolved = item.rsd === 1;

    return (
      <Card variant="outlined">
        <CardContent>
          <Stack spacing={1.5}>
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              justifyContent="space-between"
              alignItems={{ xs: 'flex-start', md: 'center' }}
              spacing={1}
            >
              <Box>
                <Typography variant="subtitle1" fontWeight={700}>
                  {item.rct}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.rtx}
                </Typography>
              </Box>

              <Stack direction="row" spacing={1}>
                <Chip
                  size="small"
                  label={`${Number(item.cnf || 0).toFixed(0)}% confidence`}
                />
                <Chip
                  size="small"
                  label={item.ssn || item.ssc}
                  color={resolved ? 'success' : 'default'}
                  variant={resolved ? 'filled' : 'outlined'}
                />
              </Stack>
            </Stack>

            {item.rsn ? (
              <Alert severity="info" variant="outlined">
                {item.rsn}
              </Alert>
            ) : null}

            {!resolved ? (
              <Stack direction="row" spacing={1} flexWrap="wrap">
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<CheckCircleOutlineIcon />}
                  disabled={busy}
                  onClick={() => this.props.onAccept(item)}
                >
                  Accept
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<EditOutlinedIcon />}
                  disabled={busy}
                  onClick={() => this.props.onModify(item)}
                >
                  Modify
                </Button>
                <Button
                  size="small"
                  color="inherit"
                  startIcon={<HideSourceOutlinedIcon />}
                  disabled={busy}
                  onClick={() => this.props.onIgnore(item)}
                >
                  Ignore
                </Button>
              </Stack>
            ) : null}
          </Stack>
        </CardContent>
      </Card>
    );
  }
}
